module.exports = __webpack_public_path__ + "static/media/serum.2ee65c12.png";